import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "w-64 px-2 overflow-y-auto scroll-box h-screen code-box",
  style: {"height":"100%"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"color":"#f50"} }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { style: {"font-size":"16px","line-height":"2","color":"#fff"} }
const _hoisted_7 = { style: {"font-weight":"600","font-size":"18px"} }
const _hoisted_8 = { style: {"font-weight":"600","font-size":"18px"} }

import request from "../../common/request";
import { computed, onMounted } from "vue";
import { ref, watch, reactive } from "vue";
import { v4 as uuidv4 } from "uuid";
import AlarmItem from "./common/AlarmItem.vue";
/**操作日志记录 */
import { operateLogs } from "@/common/logs";
import { QuotaAlarmItem } from "./common/AlarmItem.vue";
import { getLanguage, getTranslation } from "@/common/translate";

interface Props {
  hideExpertCareOptions?: boolean // 是否隐藏专家看护选项，诊断管理中需要显示，报警管理中需要隐藏
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SmartAlarm',
  props: {
    hideExpertCareOptions: { type: Boolean, default: false }
  },
  setup(__props: any) {

operateLogs("Access system config");

let language: any = ref('English')
const getLang = () => {
   language.value = 'English'
}
getLang()

/**操作日志记录 */

const props = __props

let showExpertCareOptions = computed<boolean>(() => {
  return !props.hideExpertCareOptions
});

const modalState = reactive({
  visible: false,
  title: "说明",
  confirmLoading: false,
  roleName: "",
  meun: [],
});
const sensorsSource = ref<any>([]);
const expertCare = ref<boolean>(null);

// 新增
const add = () => {
  modalState.visible = true;
};
// 查询
const search = async () => {

  const sConfig = {
    params: { machineId: currentMachine.value.key },
    headers: {
      requestId: uuidv4(),
    },
  };
  var sResult = await request.get("/api/sensors", sConfig);
  sensorsSource.value = [];
  if (sResult) {
    sensorsSource.value = sResult.data;
  }
  const config = {
    params: { machineId: currentMachine.value.key },
    headers: {
      requestId: uuidv4(),
    },
  };
  const DefaultRangeCount = 12;
  const DefaultLimitCount = 4;
  const DefaultIntervalDays = 7;
  const DefaultIntervalTimes = 1;
  const result = await request.get("/api/sensors/quota-alarm", config);
  if (showExpertCareOptions.value) {
    if (result.data.length > 0 && result.data[0].expertCare != null) {
      expertCare.value = result.data[0].expertCare;
    } else {
      expertCare.value = true;
    }
    console.log(expertCare.value)
  } else {
    expertCare.value = null;
  }
  sensorsSource.value.forEach((item: any, index: any) => {
    item.table = []

    item.dataType && item.dataType.forEach((element: any) => {
      let data = result.data.find((t: any) => t.dataType == element && t.sensorId == item.id)
      if (data && data.sensorId) {
        item.table.push(data)
      } else {
        let configItem = {
          _id: null,
          sensorId: item.id,
          sensorPlace: item.sensorPlace,
          machineId: item.machineId,
          dataType: element,
          enable: false,
          expertCare: expertCare.value,
          level1Threshold: null,
          level1RangeCount: DefaultRangeCount,
          level1LimitCount: DefaultLimitCount,
          level1IntervalDays: DefaultIntervalDays,
          level1IntervalTimes: DefaultIntervalTimes,
          level2Threshold: null,
          level2RangeCount: DefaultRangeCount,
          level2LimitCount: DefaultLimitCount,
          level2IntervalDays: DefaultIntervalDays,
          level2IntervalTimes: DefaultIntervalTimes,
          level3Threshold: null,
          level3RangeCount: DefaultRangeCount,
          level3LimitCount: DefaultLimitCount,
          level3IntervalDays: DefaultIntervalDays,
          level3IntervalTimes: DefaultIntervalTimes,
          level4Threshold: null,
          level4IntervalDays: DefaultIntervalDays,
          level4IntervalTimes: DefaultIntervalTimes
        } as QuotaAlarmItem
        item.table.push(configItem)
      }
    });
  })
};

/* 左侧区域-设备 数据加载 */
// 在组件加载完成后执行一些操作
let currentMachine = ref<any>();
const selectTree = (key: any, val: any) => {
  if (val.node.type == "machine") {
    currentMachine.value = val.node;
    search();
  }
};

let filterKeyWord = ref<any>();
let treeData = ref<any>();

const onExpand = (keys: string[]) => {
  expandedKeys.value = keys;
  autoExpandParent.value = false;
};
const expandedKeys = ref<(string | number)[]>([]);
const autoExpandParent = ref<boolean>(true);

watch(filterKeyWord, () => {
  expandedKeys.value = [];
  sonKey(treeData.value);
  autoExpandParent.value = true;
});
const sonKey = (item: any) => {
  item.forEach((element: any) => {
    if (element.title.indexOf(filterKeyWord.value) > -1) {
      // expandedKeys.value.push(key);
      expandedKeys.value.push(element.key);
    }
    if (element.children && element.children.length) {
      sonKey(element.children);
    }
  });
};
const getParentKey = (
    key: string | number,
    tree: any
): string | number | undefined => {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (
          node.children.some((item: { key: string | number }) => item.key === key)
      ) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
};


//***角色车间***//
onMounted(() => {
  //loadMember()
  var requestId = uuidv4();
  loadFactory(requestId);
});

let factoryList = ref<any>();
let allFactory: any = ref([])
const loadFactory = (requestId: any) => {
  const config = {
    params: {},
    headers: {
      requestId: requestId,
    },
  };
  request.get("/api/factories", config).then((res: any) => {
    if (res) {
      allFactory.value = res.data;
      // 2级工厂
      var list = res.data.map((t: any) => ({
        key: t._id,
        title: t.factoryName,
        value: t._id,
        label: t.factoryName,
        parentId: t.parentId,
        id: t._id,
        type: "factory",
        children: t.groups.map((group: any) => ({
          type: "group",
          value: group.sonID,
          label: group.name,
          title: group.name,
          key: group.sonID,
        })),
      }));
      let factory: any = [];
      let parentFs = list.filter((p: any) => !p.parentId)
      parentFs.map((d: any) => {
        let sonFactory = list.filter((p: any) => p.parentId === d.id)
        if (sonFactory && sonFactory.length) {
          d.children = sonFactory
        }
        factory.push(d);
      })

      factoryList.value = factory;
      loadMachine(requestId);
    }
  });
};
const loadMachine = async (requestId: any) => {
  let factoryIds = allFactory.value.map((p: any) => p._id)
  let res = await request.post("/api/machines/all", { factoryIds: factoryIds })
  factoryList.value.forEach((element: any) => {
    if (res) {
      element.children.forEach((sonFact: any) => {
        if (sonFact.type == "factory" && sonFact.children) {
          sonFact.children.forEach((groupFact: any) => {
            if (groupFact.type == "group") {
              groupFact.children = res.data
                  .filter((t: any) => t.groupId == groupFact.value)
                  .map((t: any) => ({
                    type: "machine",
                    ...t,
                    value: t.id,
                    label: t.machineName,
                    title: t.machineName,
                    key: t.id,
                  }));
            }
          });
        } else if (sonFact.type == "group") {
          sonFact.children = res.data
              .filter((t: any) => t.groupId == sonFact.value)
              .map((t: any) => ({
                type: "machine",
                ...t,
                value: t.id,
                label: t.machineName,
                title: t.machineName,
                key: t.id,
              }));
        }
      });
    }
  });
  setTimeout(() => {
    treeData.value = factoryList.value;
  }, 100);
};

let memberList: any = ref([])
const loadMember = async () => {
  const config = {
    params: {
      skip: 1,
      take: 10000,
      factoryId: localStorage.getItem('factory_id')
    },
    headers: {
      requestId: uuidv4(),
    },
  };

  let result = await request.get('/api/members', config)
  if (result && result.data) {
    memberList.value = result.data.list
  }
}

const aiColumns = [
  {
    title: getLanguage("设备类型"),
    dataIndex: "type",
    align: "center",
  },
  {
    title: getLanguage("采用标准"),
    dataIndex: "standard",
    align: "center",
  },
];
const standardData = [
  {
    type: getLanguage("电机类"),
    standard: "ISO",
  },
  {
    type: getLanguage("泵类"),
    standard: "ISO",
  },
  {
    type: getLanguage("泵类"),
    standard: "API",
  },
  {
    type: getLanguage("往复类"),
    standard: "ISO",
  },
  {
    type: getLanguage("风机类"),
    standard: "API",
  },
  {
    type: getLanguage("齿轮类"),
    standard: "ISO",
  },
  {
    type: getLanguage("螺杆式"),
    standard: "API",
  },
  {
    type: getLanguage("汽轮机"),
    standard: "ISO",
  },
  {
    type: getLanguage("通用设备"),
    standard: "ISO",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_question_circle_outlined = _resolveComponent("question-circle-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_unref(showExpertCareOptions)?{}:{'padding':'30px 0'}),
    class: "bule_list_page"
  }, [
    _createVNode(_component_a_layout_content, { style: {"padding":"0 20px","height":"100%"} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, {
          type: "flex",
          style: {"height":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              span: 5,
              order: 1,
              style: {"height":"100%"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_a_input_search, {
                    value: _unref(filterKeyWord),
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(filterKeyWord) ? (filterKeyWord).value = $event : filterKeyWord = $event)),
                    style: {"margin-bottom":"8px"},
                    placeholder: _unref(getLanguage)('输入区域或设备名称筛选')
                  }, null, 8, ["value", "placeholder"]),
                  _createVNode(_component_a_tree, {
                    class: "draggable-tree",
                    draggable: "",
                    "block-node": "",
                    autoExpandParent: autoExpandParent.value,
                    "expanded-keys": expandedKeys.value,
                    "tree-data": _unref(treeData),
                    onExpand: onExpand,
                    onSelect: selectTree
                  }, {
                    title: _withCtx(({ title }) => [
                      (_unref(getTranslation)(title).indexOf(_unref(filterKeyWord)) > -1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                            _createTextVNode(_toDisplayString(_unref(getTranslation)(title).substr(0, _unref(getTranslation)(title).indexOf(_unref(filterKeyWord)))) + " ", 1),
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(filterKeyWord)), 1),
                            _createTextVNode(" " + _toDisplayString(_unref(getTranslation)(title).substr(
                      _unref(getTranslation)(title).indexOf(_unref(filterKeyWord)) + _unref(filterKeyWord).length
                    )), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(getTranslation)(title)), 1))
                    ]),
                    _: 1
                  }, 8, ["autoExpandParent", "expanded-keys", "tree-data"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              span: 19,
              order: 2,
              style: {"padding-bottom":"20px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: add,
                  style: {"margin-bottom":"15px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_question_circle_outlined),
                    _createTextVNode(" " + _toDisplayString(_unref(getLanguage)('说明')), 1)
                  ]),
                  _: 1
                }),
                (sensorsSource.value && sensorsSource.value.length>0 && _unref(showExpertCareOptions))
                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                      key: 0,
                      class: "mt-2",
                      label: _unref(getLanguage)('是否专家看护', _unref(language)),
                      name: "alarmType"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          name: "alarmType",
                          value: expertCare.value,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((expertCare).value = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getLanguage)('是', _unref(language))), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getLanguage)('否', _unref(language))), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sensorsSource.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.sensorId
                  }, [
                    (_openBlock(), _createBlock(AlarmItem, {
                      sensor: item,
                      key: item.sensorId,
                      deviceId: _unref(currentMachine).key,
                      "expert-care": expertCare.value,
                      onSearch: search
                    }, null, 8, ["sensor", "deviceId", "expert-care"]))
                  ]))
                }), 128)),
                (!sensorsSource.value || !sensorsSource.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_a_alert, {
                        message: _unref(getLanguage)('未选择设备或没有配置测点'),
                        type: "warning",
                        "show-icon": ""
                      }, null, 8, ["message"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      width: 850,
      maskClosable: false,
      visible: modalState.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((modalState.visible) = $event)),
      title: modalState.title,
      "confirm-loading": modalState.confirmLoading,
      footer: null
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(_toDisplayString(_unref(getLanguage)('基于国际、国家或行业内既定标准，实现对设备运行状态进行监测。同时，可纵向参考设备历史运行数据，横向比较同类设备运行数据，确定各报警等级的阈值。')), 1),
          _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(getLanguage)('但依据标准设定的绝对合理的阈值很难获取，设定过高的报警阈值会造成设备故障')), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getLanguage)('漏报')), 1),
          _createTextVNode(_toDisplayString(_unref(getLanguage)('的风险，而阈值过低又会来带大量的')), 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(getLanguage)('误报警')), 1),
          _createTextVNode(_toDisplayString(_unref(getLanguage)('，给现场处理造成极大的压力；此外，仅按照标准规定中的几种指标设定的阈值报警所能发现的故障模式有限。设置和修改阈值也面临必需手动调整与工作量大等问题。')) + " ", 1),
          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(getLanguage)('根据各类国际、国家、行业标准，根据对目前所有设备类型，参照相应标准，做如下统计：')), 1),
          _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
          _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1))
        ]),
        _createVNode(_component_a_table, {
          columns: aiColumns,
          "data-source": standardData,
          pagination: false,
          size: "small",
          bordered: ""
        })
      ]),
      _: 1
    }, 8, ["visible", "title", "confirm-loading"])
  ], 4))
}
}

})